import { useNavigation } from "@react-navigation/native"
import { StackNavigationProp } from "@react-navigation/stack"
import { Button, useTheme } from "capsule"
import React, { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { StyleSheet, View } from "react-native"
import FastImage from "react-native-fast-image"
import { Text } from "react-native-paper"

import { images } from "../../assets/images"
import { RegisterPecanWorkflowExplanationNS } from "../../features/i18n/constants"
import { OnboardingParamList } from "../../features/Navigation/types"

const RegisterPecanWorkflowExplanation = () => {
  const {
    colors: {
      black,
      surface: { background },
    },
    dimensions: { spacing },
  } = useTheme()
  const { t } = useTranslation(RegisterPecanWorkflowExplanationNS)

  const navigation =
    useNavigation<StackNavigationProp<OnboardingParamList, "RegisterPecanWorkflowExplanation">>()
  const s = useMemo(
    () => ({
      view: [
        styles.view,
        {
          backgroundColor: background,
          paddingHorizontal: spacing * 2,
        },
      ],
      separator: [styles.separator, { backgroundColor: black.separator }],
      section: styles.section,
      text: styles.text,
      bold: styles.bold,
      button: styles.button,
    }),
    [background, black.separator, spacing],
  )
  const handleStart = () => {
    navigation.navigate("RegisterCgu")
  }
  return (
    <View style={s.view}>
      <View style={s.section}>
        <FastImage
          source={images.social_protection as number}
          style={styles.icon}
          resizeMode="contain"
        />

        <Text style={[s.text, s.bold]}>{t("explanation")}</Text>
        <Text style={s.text}>{t("someStepNeeded")}</Text>
      </View>
      <View style={s.separator} />
      <View style={s.section}>
        <Text style={s.text}>{t("takeATime")}</Text>
        <Text style={s.text}>{t("createYourProgram")}</Text>
        <Button style={s.button} onPress={handleStart} testID="start_button">
          {t("start")}
        </Button>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  view: {
    flex: 1,
    gap: 40,
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
  },
  section: {
    gap: 8,
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  text: {
    textAlign: "center",
  },
  bold: {
    fontWeight: "bold",
  },
  button: {
    width: "100%",
    height: 40,
  },
  separator: {
    height: 1,
    width: "60%",
  },
  icon: {
    marginBottom: 20,
    marginRight: 28,
    width: 122,
    height: 96,
  },
})

export default RegisterPecanWorkflowExplanation
